<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入批次号编码" ref="keepFocus">
      <div slot="customize">
        <span style="padding: 0 20px; font-size: 16px; font-weight: bold;">
          总数: {{ allAmount }}
        </span>
        <el-button type="primary" @click="submit(1)">一键移库</el-button>
        <el-button type="danger" @click="submit(2)">驳回</el-button>
      </div>
    </ScanQuery>
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query"
      :scroll=false>
      <!-- <ImgView slot="productImgAction" :src="transferInfo.img"></ImgView> -->
      <ImgPreviews slot="productImgAction" slot-scope="{text, record, index}" :images="[record.img]"></ImgPreviews>
      <template slot="singleProductFlag" slot-scope="{text, record, index}">
        <span
          :class="record.systemSource == 1 && (record.singleProductFlag == 1 || record.singleProductFlag == true) && record.processingStatus == 2 ? 'prominent' : ''">{{
      record.amount == 1
        ? "单件" : "多件" }}</span>
      </template>
      <div class="flex" slot="pkgCode" slot-scope="{text, record }">
        <span>{{ text }}</span>
        <el-tag size="small" v-if="record.spiltType == 1" type="danger">拆</el-tag>
        <el-tag size="small" v-if="record.crossDockingFlag" type="danger">可越库</el-tag>
      </div>
      <div slot="productName" slot-scope="{text,record}">
        <a target='_blank' :href="record.productLink" v-if="record.productLink">{{ text }}</a>
        <span v-else>{{ text }}</span>
      </div>
      <div slot="specialCheckRequirement" slot-scope="{text,record}">
        <ImgView :src="record.specialCheckRequirementImg" v-if="record.specialCheckRequirementImg"></ImgView>
        {{ text || '-' }}
      </div>
      <template slot="targetRegionAction" slot-scope="{text, record, index}">
        <el-select v-model="record.targetRegion" placeholder="请选择">
          <el-option v-for="item in regionList" :key="item.regionCode" :label="item.regionName"
            :value="item.regionCode">
          </el-option>
        </el-select>
      </template>
    </WmsTable>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import IptNumber from "@/components/IptNumber";
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import ImgPreviews from "@/components/ImgPreviews"
import { columns, testDataSource } from "@/views/inHouse/shiftConfirmData";
import { getPkgInfoMonde, transferMondeConfirm } from "@/apis/inHouse";

export default {
  title: '库区移动确认',
  name: "shiftConfirm",
  components: {
    ScanQuery,
    IptNumber,
    WmsTable,
    ImgView,
    ImgPreviews
  },
  data() {
    return {
      columns,
      query: {
        code: '',
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource: [],
      transferInfo: {}
    }
  },
  computed: {
    allAmount: function () {
      return this.dataSource.reduce((pre, item) => {
        if (!item.amount) {
          return pre
        } else {
          return pre + item.amount
        }
      }, 0)
    },
    regionList: function () {
      return this.$store.getters.getRegionList
    },
    regionMap: function () {
      let _map = {}
      this.$store.getters.getRegionList.forEach(item => {
        _map[item.regionCode] = item.regionName
      })
      return _map
    }
  },
  methods: {
    queryCall: function (payload) {
      // console.log(payload)
      if (!payload.code) return
      this.query.code = payload.code
      this.getDataSource()
    },
    pageChangeCall: function (payload) {
      this.query = {
        ...this.query,
        ...payload
      }
      console.log(this.query)
    },
    getDataSource: function () {
      getPkgInfoMonde({ pkgCode: this.query.code }).then(({ code, data }) => {
        if (code === 0) {
          this.transferInfo = data
          this.dataSource = data.itemList
        }
      })
    },
    submit: function (flag) {
      const params = {
        ...this.transferInfo,
        transferStatus: flag, // 0-待确认，1-调拨确认，2-调拨驳回
      }
      transferMondeConfirm(params).then(({ code, data, msg }) => {
        if (code === 0) {
          this.$message.success('完成')
          this.transferInfo = {}
          this.dataSource = []
        } else if (code == '26010019') {
          this.$confirm(msg, "部分批次包无法移库", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
          });
        }
      })
    }
  },
  mounted() {
    var focusFunc = setInterval(() => {
      // console.log(document.activeElement)
      if (!!window.getSelection().toString()) {
        return
      }
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
        return
      }
      if (this.$refs.keepFocus) {
        this.$refs.keepFocus.focusIpt()
      }
    }, 300);
  },
  beforeUnmount() {
    console.log('beforeUnmount')
    clearInterval(focusFunc)
  }
}
</script>

<style scoped>
.prominent {
  color: red;
  font-size: large;
  font-weight: 600;
}
</style>